existingLines